import {
    CalendarToday as IconAvailableStatus,
    EventAvailable as IconScheduledStatus,
    EventBusy as IconUnavailableStatus,
} from "@mui/icons-material";
import { Paper, Stack, Typography } from "@mui/material";

import { GqlFieldworkerAvailability, GqlFieldworkerAvailabilityStatus } from "~/__generated__";

type Props = {
    availability: GqlFieldworkerAvailability;
};

export default function AvailabilityItem({ availability }: Props) {
    const { status, name } = availability;
    const currentStatusConfig = STATUS_CONFIG[status];

    const columnLayoutBreakpoint = "@container (max-width: 110px)";
    const mobileLayoutBreakpoint = "@container (max-width: 85px)";

    return (
        <Paper
            sx={{
                backgroundColor: currentStatusConfig.backgroundColor,
                color: currentStatusConfig.color,
                margin: 1,
                padding: 1,
                containerType: "inline-size",
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                columnGap={1}
                justifyContent="flex-start"
                sx={{
                    [columnLayoutBreakpoint]: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                    [mobileLayoutBreakpoint]: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    },
                }}
            >
                {currentStatusConfig.icon}

                <Typography
                    variant="body2"
                    sx={{
                        [mobileLayoutBreakpoint]: {
                            display: "none",
                        },
                    }}
                >
                    {name}
                </Typography>
            </Stack>
        </Paper>
    );
}

const STATUS_CONFIG = {
    [GqlFieldworkerAvailabilityStatus.Scheduled]: {
        backgroundColor: "secondary.main",
        color: "primary.contrastText",
        icon: <IconScheduledStatus fontSize="inherit" />,
    },
    [GqlFieldworkerAvailabilityStatus.Available]: {
        backgroundColor: "primary.main",
        color: "primary.contrastText",
        icon: <IconAvailableStatus fontSize="inherit" />,
    },
    [GqlFieldworkerAvailabilityStatus.Unavailable]: {
        backgroundColor: "background.default",
        color: "text.primary",
        icon: <IconUnavailableStatus fontSize="inherit" />,
    },
};
